import Controller from '../abstracts/Controller';

export default class ModalGenericController extends Controller {
  static get COMPONENTS() {
    return [
    ];
  }
}
